import { AuditLogTable } from '../../components/audit/AuditLogTable';

interface Props { tenantId: number; }

export default function TenantDetailAudit({ tenantId }: Props) {
  return <AuditLogTable scope={{ tenantId }} availableTenants={[]} availableActors={[]} />;
}
